module.exports = __webpack_public_path__ + "img/Hello_There.76d82cde.jpg";